<template>
  <div :class="rootClass" :style="pageTopStyle">
    <van-sticky :offset-top="0" class="search-sticky">
      <head-child
        class="themed-top-search"
        :change="true"
        :theme-color="bannerThemeColor"
        no-right
      >
        <template #left>
          <div v-if="boo2 && !hideLocation" class="themed-top-search__location" @click="Switch">
            <van-icon name="location-o" size="0.9rem" />
            <span class="themed-top-search__location-text ellipsis">{{ address || '定位中' }}</span>
            <van-icon name="arrow-down" size="0.65rem" />
          </div>
          <button v-else type="button" class="themed-top-search__back" aria-label="返回" @click="goback">
            <van-icon name="arrow-left" size="1.35rem" />
          </button>
        </template>
        <template #middle>
          <van-search
            ref="searchField"
            v-model="value"
            class="themed-top-search__input"
            placeholder="搜索商品"
            shape="round"
            background="transparent"
            @focus="seach1"
            @search="seach"
          />
        </template>
      </head-child>

      <sort-filter
        v-if="showSelect"
        class="search-sort"
        :price-type="priceType"
        @sort-default="setNomal"
        @sort-price="setPrictType"
      />
    </van-sticky>

    <div class="search-body">
      <seachview
        ref="seach"
        :value="value"
        :type="2"
        @showtop="showTop"
        :id="id"
        :hotType="hotType"
      />
    </div>
  </div>
</template>

<script>
import HeadChild from "../components/HeadChild";
import Seachview from "../components/index/Seachview.vue";
import SortFilter from "../components/goodlist/SortFilter.vue";
import {
  getHomeTopBackgroundStyle,
  getStoredHomeBannerThemeColor,
  getStoredHomeBannerThemeIndex,
  getStoredGiftPackageBannerThemeColor,
  getStoredGiftPackageBannerThemeIndex,
  setStoredHomeBannerThemeColor,
  setStoredGiftPackageBannerThemeColor,
  HOME_DEFAULT_TOP_COLOR,
  GIFT_PACKAGE_DEFAULT_TOP_COLOR,
  isGiftPackageMallSource,
} from '@/utils/themeColor';
import { mapState } from 'vuex';
let initViewfinish = false
export default {
  name: 'SearchGoods',
  components: { HeadChild, Seachview, SortFilter },
  data() {
    return {
      priceType: null,
      value: '',
      seachvalue: '',
      boo2: true,
      showSelect: false,
      id: null,
      hotType: null,
      bannerThemeColor: HOME_DEFAULT_TOP_COLOR,
    }
  },
  computed: {
    ...mapState({
      address: state => state.address
    }),
    rootClass() {
      return { 'search-page': true }
    },
    /** 商品列表等场景进入：不展示定位，左侧为返回 */
    hideLocation() {
      return this.$route.query.showType === 'noLocation'
    },
    pageTopStyle() {
      const defaultColor = isGiftPackageMallSource()
        ? GIFT_PACKAGE_DEFAULT_TOP_COLOR
        : HOME_DEFAULT_TOP_COLOR
      return getHomeTopBackgroundStyle(this.bannerThemeColor, '12rem', defaultColor)
    },
  },
  created() {
    if (initViewfinish) {
      initViewfinish = false
      this.initView()
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0
    }
  },
  mounted() {},
  methods: {
    showTop() {
      this.showSelect = true
    },
    setPrictType() {
      if (this.priceType) {
        if (this.priceType == '1') {
          this.priceType = '0'
        } else {
          this.priceType = '1'
        }
      } else {
        this.priceType = '1'
      }
      this.$refs.seach.setPriceType(this.priceType)
    },
    setNomal() {
      this.priceType = null
      this.$refs.seach.setPriceType(this.priceType)
    },
    seach1() {
      this.boo2 = false
      this.$nextTick(() => {
        const field = this.$refs.searchField
        if (field && field.$el) {
          const input = field.$el.querySelector('input')
          if (input) input.focus()
        }
      })
    },
    seach() {
      this.$refs.seach.seach(this.value);
    },
    goback() {
      this.$router.back()
    },
    Switch() {
      this.$router.push("SelectAdderss");
    },
    initView() {
      this.id = this.$route.query.id
      this.hotType = this.$route.query.hotType
      this.value = ''
      this.seachvalue = ''
      this.boo2 = this.$route.query.showType !== 'noLocation'
      this.showSelect = false
      this.loadBannerTheme()
      this.$nextTick(() => {
        this.$refs.seach.reset();
      })
    },
    loadBannerTheme() {
      const isGiftMall = isGiftPackageMallSource()
      const defaultColor = isGiftMall ? GIFT_PACKAGE_DEFAULT_TOP_COLOR : HOME_DEFAULT_TOP_COLOR
      const storedIndex = isGiftMall
        ? getStoredGiftPackageBannerThemeIndex()
        : getStoredHomeBannerThemeIndex()
      this.bannerThemeColor = isGiftMall
        ? getStoredGiftPackageBannerThemeColor()
        : getStoredHomeBannerThemeColor()
      const cityCode = localStorage.getItem('cityCode')
      const bathId = localStorage.getItem('bathId')
      if (!cityCode || !bathId) return
      this.$api.getQueryRotation({
        cardId: localStorage.getItem('cardId') || '',
        cityCode,
        upgradeFlag: localStorage.getItem('upgradeFlag'),
        bathId,
        hotType: 'A',
        showPositionCode: isGiftMall ? '3' : '0',
      }).then((res) => {
        if (res.code !== 0 || !res.data || !res.data.length) return
        const index = Math.min(storedIndex, res.data.length - 1)
        const item = res.data[index] || res.data[0]
        const color = item.themeColor || defaultColor
        this.bannerThemeColor = color
        if (isGiftMall) {
          setStoredGiftPackageBannerThemeColor(color, index)
        } else {
          setStoredHomeBannerThemeColor(color, index)
        }
      }).catch(() => {})
    },
  },
  beforeRouteEnter(to, from, next) {
    to.meta.keepAlive = true
    const isDetail = /^\/Details/i.test(from.path);
    if (!isDetail) {
      next((vm) => {
        vm.$nextTick(() => {
          vm.initView()
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0
        })
      });
    } else {
      initViewfinish = true
      next();
    }
  },
  activated() {
    const scrollTop = this.$route.meta.scrollTop;
    if (scrollTop) {
      this.$nextTick(() => {
        document.documentElement.scrollTop = scrollTop;
        document.body.scrollTop = scrollTop;
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    const isDetail = /^\/Details/i.test(to.path);
    if (isDetail) {
      from.meta.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    } else {
      from.meta.scrollTop = 0;
    }
    next();
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/themedTopSearch.scss';

.search-page {
  min-height: 100vh;
  background-color: #f5f5f5;
  transition: background-image 0.45s ease;
}

.search-sticky {
  z-index: 100;
}

.search-sort {
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
}

.search-body {
  padding-bottom: 1.5rem;
}
</style>
